import React, { FC } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface IAccordion {
  title: JSX.Element;
  isExpanded?: boolean;
  containerClass?: string;
  summaryClass?: string;
  detailsClass?: string;
  isDefaultExpanded?: boolean;
  handleChange?: () => void;
}

const AccordionCustom: FC<IAccordion> = ({ title,
  isExpanded,
  containerClass,
  summaryClass,
  detailsClass,
  isDefaultExpanded,
  children,
  handleChange }) => {
  return (
    <Accordion
      className={`!border-none !shadow-none ${containerClass}`}
      defaultExpanded={isDefaultExpanded} {...handleChange ? { expanded: isExpanded, onChange: handleChange }: null}>
      <AccordionSummary className={`!p-0 ${summaryClass}`}
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${title}-content`}
        id={`${title}-header`}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails className={`!p-0 ${detailsClass}`}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionCustom;
